import {
  BlockContextProvider,
  useBlockProps,
  useInnerBlocksProps,
} from "@wordpress/block-editor";

import AllInspectorSettings from "./InspectorControls";

import { getDefaultCardTemplate } from "../../TestimonialCard/Edit";

import cardMetaData from "../../TestimonialCard/block.json";
import metadata from "../block.json";

import "../style.scss";

export default function Edit(props) {
  return (
    <>
      <AllInspectorSettings {...props} />
      <BlockContextProvider
        value={{
          rootId: props.clientId,
        }}
      >
        <Content {...props} />
      </BlockContextProvider>
    </>
  );
}

const DEFAULT_TEMPLATE = [
  [
    "brandy/testimonial-card",
    cardMetaData.attributes,
    getDefaultCardTemplate({
      name: "Anthony Nguyen",
      ratingPoint: 4,
    }),
  ],
  [
    "brandy/testimonial-card",
    cardMetaData.attributes,
    getDefaultCardTemplate({
      name: "Thomas James",
      avatarUrl:
        "https://images.wpbrandy.com/uploads/blocks-test-img-2-min.png",
    }),
  ],
  [
    "brandy/testimonial-card",
    cardMetaData.attributes,
    getDefaultCardTemplate({
      name: "Linda Rosabella",
      ratingPoint: 3,
      avatarUrl:
        "https://images.wpbrandy.com/uploads/blocks-test-img-3-min.png",
    }),
  ],
];

export function Content(props) {
  const { isSave = false, attributes, clientId } = props;

  const parentProps = {
    ...getDataAttributes(attributes),
  };

  const innerProps = {
    className: attributes.hasSlider
      ? "embla__container"
      : "testimonials-list-wrapper",
    ...(isSave
      ? {}
      : {
          onClick: function (e) {
            if (!e.target.classList.contains("embla__container")) {
              return;
            }
            window.wp.data.dispatch("core/block-editor").selectBlock(clientId);
          },
        }),
  };

  const blockProps = isSave
    ? useBlockProps.save(parentProps)
    : useBlockProps(parentProps);

  const innerBlockProps = isSave
    ? useInnerBlocksProps.save(innerProps)
    : useInnerBlocksProps(innerProps, {
        template: DEFAULT_TEMPLATE,
        renderAppender: false,
      });

  return (
    <div {...blockProps}>
      <WithSlider attributes={attributes}>
        <div {...innerBlockProps} />
      </WithSlider>
    </div>
  );
}

function WithSlider(props) {
  return props.attributes.hasSlider ? (
    <div
      className="embla"
      data-auto-play={
        props.attributes.autoplay ?? metadata.attributes.autoPlay.default
          ? "true"
          : "false"
      }
      data-loop={
        props.attributes.infiniteLoop ??
        metadata.attributes.infiniteLoop.default
          ? "true"
          : "false"
      }
      data-auto-play-delay={
        props.attributes.autoPlayDelay ??
        metadata.attributes.autoPlayDelay.default
      }
    >
      <div className="embla__viewport">{props.children}</div>
      <div class="embla__buttons">
        <button
          class="embla__button embla__button--prev"
          type="button"
          disabled=""
          aria-label="Slider previous button"
        >
          <svg
            class="embla__button__svg"
            width="7"
            height="12"
            viewBox="0 0 7 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 11L1 6L6 1"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <button
          class="embla__button embla__button--next"
          type="button"
          disabled=""
          aria-label="Slider next button"
        >
          <svg
            class="embla__button__svg"
            width="7"
            height="12"
            viewBox="0 0 7 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L6 6L1 11"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
      <div className="embla__progress">
        <div
          class="embla__progress__bar"
          style={{
            transform: `translate3d(0%,0px,0px)`,
          }}
        ></div>
      </div>
      <div class="embla__dots"></div>
    </div>
  ) : (
    <div class="wp-block-brandy-testimonials__list">{props.children}</div>
  );
}

function getDataAttributes(attributes) {
  return {
    style: {
      "--embla-slides-desktop": attributes.slides.desktop.toString() ?? "3",
      "--embla-slides-tablet": attributes.slides.tablet.toString() ?? "2",
      "--embla-slides-mobile": attributes.slides.mobile.toString() ?? "1",
      "--embla-gap": attributes.itemsSpacing ?? "30px",
      ...(attributes.hasSlider && (attributes.navigation.enabled ?? true)
        ? {
            "--embla-button-width":
              attributes.navigation?.size ??
              metadata.attributes.navigation.default.size,
            "--embla-button-height":
              attributes.navigation?.size ??
              metadata.attributes.navigation.default.size,
            "--embla-button-icon-width":
              attributes.navigation?.iconSize ??
              metadata.attributes.navigation.default.iconSize,
            "--embla-button-icon-height":
              attributes.navigation?.iconSize ??
              metadata.attributes.navigation.default.iconSize,
            "--embla-button-background-color":
              attributes.navigation?.backgroundColor ??
              metadata.attributes.navigation.default.backgroundColor,
            "--embla-button-background-color-hover":
              attributes.navigation?.backgroundHoverColor ??
              metadata.attributes.navigation.default.backgroundHoverColor,
            "--embla-button-icon-color":
              attributes.navigation?.iconColor ??
              metadata.attributes.navigation.default.iconColor,
            "--embla-button-icon-color-hover":
              attributes.navigation?.iconHoverColor ??
              metadata.attributes.navigation.default.iconHoverColor,
          }
        : {}),
      ...(attributes.hasSlider && attributes.navigation.enabled != null
        ? {
            "--embla-navigation-display": attributes.navigation.enabled
              ? "flex"
              : "none",
          }
        : {}),
      ...(attributes.hasSlider && attributes.pagination?.fractionSize
        ? {
            ["--embla-pagination-fraction-size"]:
              attributes.pagination.fractionSize,
          }
        : {}),
      ...(attributes.hasSlider && attributes.pagination?.enabled
        ? {
            "--embla-pagination-display": "flex",
            "--embla-pagination-bullet-color":
              attributes.pagination?.defaultColor ??
              metadata.attributes.pagination.default.defaultColor,
            "--embla-pagination-bullet-color-active":
              attributes.pagination?.activeColor ??
              metadata.attributes.pagination.default.activeColor,
            "--embla-pagination-bullet-size":
              attributes.pagination?.size ??
              metadata.attributes.pagination.default.size,
            "--embla-pagination-bullet-spacing":
              attributes.pagination?.spacing ??
              metadata.attributes.pagination.default.spacing,
          }
        : {
            "--embla-pagination-display": "none",
          }),
      ...(attributes.hasSlider && attributes.scrollbar?.enabled
        ? {
            "--embla-scrollbar-bg-color": attributes.scrollbar.defaultColor,
            "--embla-scrollbar-drag-bg-color": attributes.scrollbar.activeColor,
            "--embla-scrollbar-display": "flex",
          }
        : {
            "--embla-scrollbar-display": "none",
          }),
    },
  };
}
